const productionConfig = {
  ACCESS_KEY: "AIzaSyBHOsy7ieXVurgLMbbq3UTaJWK45BlU25o"
}

module.exports = productionConfig;



//////////////////
// WEBPACK FOOTER
// ./config/.production.js
// module id = Asao
// module chunks = 1